import styled from 'styled-components';
import KIAImage from '../ui/image/KIAImage';

const SBSStyled = styled.section`
  display: grid;
  grid-template-columns: 1.7fr 1fr;
  gap: 40px;
  > img {
    width: 100%;
  }
  > .content > h3 {
    font-size: 18px;
    line-height: 23px;
    font-weight: 400;
    margin: 0 0 8px 0;
  }
  > .content > p {
    font-size: 14px;
    line-height: 20px;
  }

  @media screen and (max-width: 940px) {
    grid-template-areas: 'image' 'text';
    grid-template-columns: 1fr;
    gap: 0;
    > .content {
      margin-top: 32px;
      max-width: 100%;
      margin: 40px 32px 0 32px;
      grid-area: text;
    }
    > img {
      grid-area: image;
    }
  }
`;

interface Props {
  image: string;
  text: string;
  link: string;
  title?: string;
}

const SBS = ({ image, text, link, title }: Props) => {
  return (
    <SBSStyled className="side_side_img_text container">
      <KIAImage
        sizes="(max-width: 768px) 100vw, 290px"
        alt="Kia car image"
        src={image}
      />
      <div className="content">
        {title && <h4 style={{ marginBottom: '.5rem' }}>{title}</h4>}
        <p>{text}</p>
        <a className="link-button" href={link}>
          Läs mer
        </a>
      </div>
    </SBSStyled>
  );
};

export default SBS;
